export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

let loadPromise = null;

/** Load Maps JavaScript API with Places library (once). */
export function loadGoogleMapsPlaces() {
  if (typeof window !== "undefined" && window.google?.maps?.places) {
    return Promise.resolve();
  }
  if (loadPromise) return loadPromise;

  if (!GOOGLE_MAPS_API_KEY) {
    return Promise.reject(new Error("Google Maps API key missing"));
  }

  loadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector("script[data-bt-google-maps]");
    if (existing) {
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", reject);
      return;
    }
    const script = document.createElement("script");
    script.dataset.btGoogleMaps = "1";
    script.async = true;
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places&language=sq&region=AL`;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Google Maps failed to load"));
    document.head.appendChild(script);
  });

  return loadPromise;
}

/** Prefer "Business Name, Address" for establishments. */
export function formatPlaceAddress(place) {
  const name = place.name?.trim() || "";
  const formatted = place.formatted_address?.trim() || "";
  if (name && formatted) {
    if (formatted.toLowerCase().startsWith(name.toLowerCase())) return formatted;
    return `${name}, ${formatted}`;
  }
  return formatted || name || "";
}
